<template>
  <div class="publication" v-if="publicationObject">
    <div class="has-text-centered back-button-wrapper">
      <router-link :to="{ name: 'AllPublications' }" class="link">← К списку публикаций</router-link>
    </div>
    <div class="publication-header page-header-wrapper" v-bind:style="headerStyle">
      <div class="publication-header-content translucent-wrapper">
        <div class="centered" v-if="!publicationObject.photo">
          <span class="button-wrapper" @click="handleLoadPhoto">
            <a class="button is-info">+</a>Добавить фото
            <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
          </span>
        </div>
        <div class="centered" v-else>
          <span class="button-wrapper" @click="deletePublicationPhoto(publicationObject.id)">
            <a class="button is-danger">-</a>Удалить фото
          </span>
        </div>
        <b-field>
          <b-input v-model="publicationObject.title" @change="handleUpdate" placeholder="Название публикации"/>
        </b-field>
        <b-field>
          <b-input type="textarea" v-model="publicationObject.description" @change="handleUpdate" placeholder="Подзаголовок публикации"/>
        </b-field>
      </div>
    </div>
    <div class="publication-text">
      <Editor v-model="text" :editorToolbar="customToolbar" placeholder="Текст публикации"/>
      <div class="save-content-button centered">
        <button class="button save-content" @click="handleSave()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
      </div>
      <div class="columns" v-if="!publicationObject.isNew">
        <div class="column delete-service" @click="deletePublication(publicationObject.id)">
          <span>Удалить</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import deepcopy from 'deepcopy'
  import { VueEditor as Editor } from 'vue2-editor'
  import router from '../../router'

  export default {
    name: 'PublicationItem',
    data () {
      return {
        updateTimer: 0,
        disabled: false,
        text: '',
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}, 'blockquote'],
          ['link', 'image']
        ]
      }
    },
    methods: {
      ...mapActions(['updatePublication', 'deletePublication', 'getPublication', 'loadPublicationPhoto', 'deletePublicationPhoto', 'savePublication', 'addPublicationPhoto']),
      handleUpdate () {
        clearTimeout(this.updateTimer)
        this.updateTimer = setTimeout(() => {
          this.publicationObject.text = this.text
          this.updatePublication(this.publicationObject)
        }, 500)
      },
      loadPhoto (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        reader.onload = (e) => {
          this.publicationObject.photo = {
            base64photo: e.target.result,
            data: formData
          }
          this.addPublicationPhoto(this.publicationObject)
        }
      },
      handleSave () {
        this.disabled = true
        this.savePublication(this.publicationObject)
        .then(() => {
          this.disabled = false
          this.$toast.open({ message: 'Сохранено' })
        })
      },
      handleLoadPhoto () {
        if (!this.publicationObject.photo) {
          this.$refs.loadPhotoButton.click()
        }
      }
    },
    computed: {
      ...mapState(['publication']),
      publicationObject () {
        if (this.publication) {
          this.text = this.publication.text
          return deepcopy(this.publication)
        } else {
          return {}
        }
      },
      headerStyle () {
        return (this.publicationObject.photo)
        ? {background: !this.publicationObject.photo.base64photo ? `url(/upload/photos/${this.publicationObject.photo})` : `url(${this.publicationObject.photo.base64photo})`}
        : {background: ''}
      }
    },
    created () {
      if (this.$route.name !== 'PublicationCreator') {
        this.getPublication(this.$route.params.id)
      } else if (!this.publication) {
        router.push({ name: 'AllPublications' })
      }
    },
    watch: {
      text () {
        this.handleUpdate()
      }
    },
    components: { Editor }
  }
</script>

<style scoped>
.back-button-wrapper {
  margin: 10px 0 0;
}
.publication-text {
  max-width: 650px;
  margin: 15px auto 10px;
}
.publication-header {
  margin: 10px 15px 25px;
  background: #eee;
  padding: 30px 20px;
}
.publication-header-content {
  max-width: 700px;
  width: 100%;
  margin: 0 auto;
}
.is-danger {
  width: 36px;
}
.delete-service {
  margin-top: 30px;
}
.save-content {
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// EditPublication.vue?416c8d2b